export class User {
    firstName: string = undefined;
    lastName: string = undefined;
    middleName: string = undefined;
    phone: string = undefined;
    email: string = undefined;
    password: string = undefined;
}